import { APP_IDS, getRuntimeAppProfile } from '../registry';

export const INSTALL_CHANGED = 'timely-install-changed';
export const INSTALL_STORAGE_KEY = 'timely-app-installed';
let pendingPrompt = null;
let installed = false;

const rememberInstalled = (value) => {
    installed = value;
    try {
        if (value) window.localStorage.setItem(INSTALL_STORAGE_KEY, 'true');
        else window.localStorage.removeItem(INSTALL_STORAGE_KEY);
    } catch { /* Installation detection still works when storage is unavailable. */ }
};

export const getInstallPrompt = () => pendingPrompt;
export const isAppInstalled = () => {
    if (typeof window === 'undefined') return false;
    if (window.matchMedia?.('(display-mode: standalone)').matches || Boolean(navigator.standalone)) {
        rememberInstalled(true);
    }
    let remembered = false;
    try { remembered = window.localStorage.getItem(INSTALL_STORAGE_KEY) === 'true'; } catch { /* Optional storage. */ }
    return installed || remembered;
};
export const consumeInstallPrompt = () => {
    const prompt = pendingPrompt;
    pendingPrompt = null;
    window.dispatchEvent(new Event(INSTALL_CHANGED));
    return prompt;
};

// Capture installation before authentication or a menu mounts.
if (typeof window !== 'undefined' && getRuntimeAppProfile().id === APP_IDS.TIMELY) {
    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) manifest.setAttribute('href', '/timely-manifest.json');
    const touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (touchIcon) touchIcon.setAttribute('href', '/images/timely365-icon.png?v=2');
    const appTitle = document.createElement('meta');
    appTitle.name = 'apple-mobile-web-app-title';
    appTitle.content = 'Timely365';
    document.head.appendChild(appTitle);

    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault();
        // A fresh browser offer also lets the menu return after uninstalling.
        rememberInstalled(false);
        pendingPrompt = event;
        window.dispatchEvent(new Event(INSTALL_CHANGED));
    });
    window.addEventListener('appinstalled', () => {
        rememberInstalled(true);
        pendingPrompt = null;
        window.dispatchEvent(new Event(INSTALL_CHANGED));
    });
    window.addEventListener('storage', (event) => {
        if (event.key !== INSTALL_STORAGE_KEY && event.key !== null) return;
        installed = false;
        window.dispatchEvent(new Event(INSTALL_CHANGED));
    });
}
